import React from "react";
import Modal from '../../common/Modal'

interface IAddSWConfirmationModal {
    onModalClick(review: boolean): void,
    header: string,
    message: string
}

const AddSWConfirmationModal: React.FC<IAddSWConfirmationModal> = (props) => {
    return (
        <Modal
            header={props.header}
            controls={(
                <>
                    <button
                        className="primary-button ok-button"
                        onClick={() => props.onModalClick(true)}
                    >
                        Continue to submit for review
                    </button>
                    <button
                        className="primary-button ok-button"
                        onClick={() => props.onModalClick(false)}
                    >
                        Cancel
                    </button>
                </>
            )}
            isOpen={true}
        >
            <p>
                {props.message}
            </p>
        </Modal>
    );
};

export default AddSWConfirmationModal;